<!--导航组件-->
<template>
  <div class="navigation-page">
    <upModel
      class="navigation-model"
      :show="value"
      :showCloseBtn="false"
      :autoHeight="true"
      @close="$emit('close')"
      v-if="!isWechat"
    >
      <ul class="app-list">
        <li
          v-for="(item, index) in appList"
          :key="index"
          class="app-item"
          @click="toMap(item.text)"
        >
          {{ item.text }}
        </li>
        <li class="app-item cancel" @click="$emit('close')">取消</li>
      </ul>
    </upModel>
  </div>
</template>

<script type="text/ecmascript-6">
import upModel from '../vue/upModel/upModel.vue'
import wechatShareMixin from '../../mixins/wechatShare.js'
import  {getPlatform} from '../../tools/getPlatform'
import Bridge from '../../lib/Bridge'
export default {
    mixins:[wechatShareMixin],
    mounted(){
        this.isWechat = getPlatform().isWechat
    },
    data(){
      return {
          isWechat: false,
          appList:[
              {text: '腾讯地图'},
            //   {text: '高德地图'},
              {text: '百度地图'},
          ],
      }
    },
    computed:{
        shareLinsters(){
            return ['openLocation']
        }
    },
    components: {
        upModel,
    },
    watch:{
        value(val){
            if(val){
                this.wxOpen()
            }
        }
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        Address:{
            default: {
                poiname: '',
                poiaddress: '',
                lat: '',
                long:''
            }
        }
    },
    methods:{
        wxOpen(){
            if(getPlatform().isWechat){
                setTimeout(()=>{
                    this.$emit('close')
                },1000)
                let title = this.Address.poiname
                let addr = this.Address.poiaddress
                let lat =  this.Address.lat || ''
                let lng =  this.Address.lng || ''
                wx.openLocation({
                    latitude: parseFloat(lat), // 纬度，浮点数，范围为90 ~ -90
                    longitude: parseFloat(lng), // 经度，浮点数，范围为180 ~ -180。
                    name: title, // 位置名
                    address: addr, // 地址详情说明
                    scale: 28, // 地图缩放级别,整形值,范围从1~28。默认为最大
                    infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转,
                })
            }
        },
        // 将百度地图经纬度转换为腾讯/高德地图经纬度
        bMapTransQQMap(lng, lat){
            let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
            let x = lng - 0.0065;
            let y = lat - 0.006;
            let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
            let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
            let lngs = z * Math.cos(theta);
            let lats = z * Math.sin(theta);

            return {
                lng: lngs,
                lat: lats
            }
        },
        //将腾讯/高德地图经纬度转换为百度地图经纬度
        qqMapTransBMap(lng, lat){
            let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
            let x = lng;
            let y = lat;
            let z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi);
            let theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi);
            let lngs = z * Math.cos(theta) + 0.0065;
            let lats = z * Math.sin(theta) + 0.006;

            return {
                lng: lngs,
                lat: lats
            }
        },
        toMap(text) {
            let title = this.Address.poiname
            let addr = this.Address.poiaddress
            let lat =  this.Address.lat || ''
            let long =  this.Address.lng || ''
            let coord = `${lat},${long}`
            let marker = `coord:${coord};title:${encodeURIComponent(title) };addr:${encodeURIComponent(addr) }`
            let  url = `https://apis.map.qq.com/uri/v1/marker?marker=${marker}&referer=yixinli`
            let destination = ''
            switch (text) {
                case '腾讯地图':
                    break
                // case '高德地图':
                //      destination = `${long},${lat}`
                //     url = `https://uri.amap.com/marker?position=${destination}&name=${encodeURIComponent(title) }&src=yixinli&coordinate=gaode&callnative=0`
                //     break
                case '百度地图':
                    let obj = this.qqMapTransBMap(lat,long)
                     destination = `${obj.lng},${obj.lat}`
                        url = `https://api.map.baidu.com/geocoder?location=${destination}&coord_type=bd09ll&output=html&src=webapp.yixinli.openMap`
                    break
            }
            const isApp = getPlatform().isYixinliApp
            if (isApp) {
                let bridge = new Bridge()
                bridge.call('openWebView', {
                    url: url,
                    isOpenByBrowser: 1
                })
            }else{
                window.location.href = url
            }
            setTimeout(()=>{
                this.$emit('close')
            },1000)
        }
    }
}
</script>

<style lang="scss">
@import '../../scss/functions';
.app-list {
  .app-item {
    text-align: center;
    font-size: pxToRem(32);
    color: #21252d;
    height: pxToRem(92);
    line-height: pxToRem(92);
    position: relative;
    &:after {
      position: absolute;
      content: '';
      left: 0;
      bottom: 0;
      width: 100%;
      height: pxToRem(2);
      background: #e9eef1;
      transform: scaleY(0.6);
    }
    &.cancel {
      border-top: pxToRem(10) solid #e9eef1;

      &:after {
        display: none;
      }
    }
  }
}
</style>
